import { render, staticRenderFns } from "./wordlist.vue?vue&type=template&id=6d09aada&scoped=true"
import script from "./wordlist.vue?vue&type=script&lang=js"
export * from "./wordlist.vue?vue&type=script&lang=js"
import style0 from "./wordlist.vue?vue&type=style&index=0&id=6d09aada&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09aada",
  null
  
)

export default component.exports